import { isFinanceProject, isGlobalProject } from 'config';

import { GradientBackgroundFinance } from './finance';
import { GradientBackgroundGlobal } from './global';

export const GradientBackground = () => {
  if (isFinanceProject()) {
    return <GradientBackgroundFinance />;
  }

  if (isGlobalProject()) {
    return <GradientBackgroundGlobal />;
  }

  return null;
};
